{
  "vehicles": "Veículos",
  "addVehicle": "Adicionar Veículo",
  "add": "Adicionar",
  "vehicleDetails": "Detalhes do Veículo",
  "registration": "Placa",
  "make": "Marca",
  "model": "Modelo",
  "year": "Ano",
  "fuelType": {
    "bifuel": "Bicombustível",
    "eletrico": "Elétrico",
    "gasoleo": "Gasóleo",
    "gasolina": "Gasolina",
    "hibrido": "Híbrido"
  },
  "fuelTypePlaceholder": "opcional",
  "assignedDrivers": "Motoristas atribuídos",
  "search": "Buscar por placa, marca ou modelo",
  "noResults": "Sem resultados",
  "noDetails": "Sem detalhes",
  "previous": "Anterior",
  "next": "Próximo",
  "page": "Página",
  "of": "de",
  "showing": "Mostrando",
  "ascending": "A-Z",
  "descending": "Z-A",
  "cancel": "Cancelar",
  "createVehicleError": "Falha ao criar veículo. Por favor, tente novamente.",
  "networkError": "Erro de rede. Por favor, tente novamente.",
  "registrationRequired": "Número de placa é obrigatório.",
  "invalidYear": "Ano inválido.",
  "fuelType.gasolina": "Gasolina",
  "fuelType.gasoleo": "Diesel",
  "fuelType.bifuel": "Bi-fuel",
  "fuelType.hibrido": "Híbrido",
  "fuelType.eletrico": "Elétrico",
  "vehicleInformation": "Informação do Veículo",
  "assignDrivers": "Atribuir Motoristas",
  "searchDrivers": "Buscar por nome ou email...",
  "selectAtLeastOneDriver": "Por favor, selecione pelo menos um motorista",
  "errorAssigningDrivers": "Erro ao atribuir motoristas",
  "selected": "selecionado",
  "select": "Selecionar",
  "noDriversFound": "Nenhum motorista encontrado que corresponda à sua busca",
  "noAvailableDrivers": "Nenhum motorista disponível para atribuir",
  "noAssignedDrivers": "Nenhum motorista atribuído",
  "loadDriversError": "Não foi possível carregar os motoristas",
  "bulkActions": {
    "selected": "Selecionados: {{count}}",
    "selectAll": "Selecionar Todos",
    "transfer": "Transferir",
    "transferVehicles": "Transferir {{count}} Veículos",
    "transferVehiclesDescription": "Selecione a empresa de destino para transferir os veículos selecionados.",
    "transferResult": "Transferidos {{success}} veículo(s). {{errors}} erro(s).",
    "transferError": "Erro ao transferir veículos: {{error}}",
    "transferLicenseErrorDrivers": "A empresa de destino não tem licenças de motoristas disponíveis para transferir motoristas relacionados.",
    "result": "Resultado da Operação"
  },
  "transfer": {
    "alsoTransferVehicles": "Também transferir {{count}} veículos relacionados",
    "alsoTransferDrivers": "Também transferir {{count}} motoristas relacionados",
    "selectCompany": "Por favor, selecione uma empresa de destino",
    "error": "Erro ao transferir",
    "noOtherCompanies": "Você precisa de pelo menos uma outra empresa para transferir.",
    "errorLoadingCompanies": "Erro ao carregar empresas",
    "transferButton": "Transferir"
  },
  "common": {
    "ok": "OK",
    "cancel": "Cancelar"
  }
}
